var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuicklinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1391_1842)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "url(#paint0_linear_1391_1842)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8049 16.2548C18.2829 15.777 18.7529 15.307 19.2364 14.8242C19.8146 15.3967 20.2082 16.0998 20.3769 16.9144C20.6981 18.4634 20.3025 19.8207 19.1971 20.9536C18.2754 21.898 17.3503 22.8403 16.3923 23.7475C15.153 24.9211 13.6739 25.2885 12.0479 24.771C10.4348 24.258 9.4277 23.1255 9.09316 21.4597C8.79486 19.9732 9.22023 18.6748 10.264 17.5824C10.5822 17.2496 10.9316 16.9466 11.2463 16.6485C11.6935 17.0966 12.1635 17.5681 12.6738 18.0791C12.2965 18.4411 11.8851 18.7986 11.5168 19.1962C10.4566 20.3426 10.8323 22.2139 12.2553 22.8527C13.1478 23.2533 14.0283 23.1652 14.746 22.4981C15.8205 21.4988 16.8589 20.4585 17.8704 19.3953C18.6551 18.5703 18.6487 17.3076 17.9305 16.4063C17.8848 16.3489 17.8367 16.2934 17.8044 16.2548H17.8049Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2334 17.7281C15.7519 18.2104 15.2868 18.6759 14.8069 19.1567C14.2689 18.6288 13.8906 17.9915 13.704 17.2542C13.301 15.6627 13.6569 14.2469 14.796 13.0609C15.7326 12.0859 16.6806 11.1183 17.6718 10.1993C18.932 9.03011 20.4349 8.70973 22.0559 9.26483C23.6785 9.82043 24.6592 10.9965 24.9367 12.693C25.1759 14.1553 24.7317 15.423 23.6869 16.4782C23.3911 16.7768 23.0977 17.0774 22.8094 17.371C22.3254 16.8828 21.8569 16.4109 21.363 15.9132C21.6832 15.5953 22.0202 15.2601 22.3577 14.9263C22.7439 14.5445 22.993 14.0969 23.0764 13.5532C23.2208 12.6103 22.7553 11.6551 21.904 11.1842C21.0558 10.7147 19.943 10.8093 19.2551 11.4729C18.2108 12.4801 17.1809 13.5046 16.1798 14.5544C15.3762 15.3972 15.3722 16.6748 16.1098 17.581C16.151 17.6315 16.1942 17.681 16.2339 17.7281H16.2334Z",
    fill: "#252525"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1391_1842",
    x: -30,
    y: -30,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1391_1842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1391_1842",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1391_1842",
    x1: 2.26667,
    y1: 2.26667,
    x2: 51.0398,
    y2: 64.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicklinks);
export default __webpack_public_path__ + "static/media/quicklinks.23a58dd398ae55e7f84c4d105fb2ab3b.svg";
export { ForwardRef as ReactComponent };